import React from 'react';

/**
 * Semantic wrapper for learner-facing HTML readings (BOK pages, previews).
 * Applies global `.learner-reading` typography and layout from `learnerReading.css`.
 */
export default function LearnerReadingBody({
  children,
  className = '',
  'aria-label': ariaLabel,
  ...rest
}) {
  return (
    <div
      className={['learner-reading', className].filter(Boolean).join(' ')}
      role="article"
      aria-label={ariaLabel}
      {...rest}
    >
      {children}
    </div>
  );
}
